import { render, staticRenderFns } from "./Bug-Report.vue?vue&type=template&id=f906766a"
import script from "./Bug-Report.vue?vue&type=script&lang=js"
export * from "./Bug-Report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports